import Axios from 'axios';

export const submitProfilePageViews = (profileId) => {
  return Axios.post(`https://profile-analytics.paddl.com/api/v1/view/${profileId}`)
    .then((response) => response?.data)
    .catch(() => undefined);
};
